import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const DISALLOWED_PASSWORD_MATCHES: string[] = [
    'salesintel',
    'circleback',
    'astegic',
    'password',
    's@lesintel',
    's@les1ntel',
    '@stegic',
    'p@ssword',
];
export const DISALLOWED_PASSWORD_ERROR_NAME: string = 'disallowedPassword';

export function passwordValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (DISALLOWED_PASSWORD_MATCHES.some((disallowedPassword: string) => control.value.toLowerCase().includes(disallowedPassword))) {
            return {
                [DISALLOWED_PASSWORD_ERROR_NAME]: true,
            }
        }

        return null;
    }
}
